/* Greys out option values that have no matching variant, and moves to a valid value instead of showing "Unavailable". Dropdown pickers only. */
(function () {
  if (window.__validOptions) return;
  window.__validOptions = true;
  var product = null;

  function exists(vals) {
    return product.variants.some(function (v) {
      return vals.every(function (x, k) { return v['option' + (k + 1)] === x; });
    });
  }

  function selectsOf(vs) {
    return Array.prototype.slice.call(vs.querySelectorAll('select'));
  }

  function normalize(vs, allowChange) {
    var s = selectsOf(vs);
    if (s.length < 2) return false;
    var vals = [];
    var changed = false;
    for (var j = 0; j < s.length; j++) {
      var opts = Array.prototype.slice.call(s[j].options);
      opts.forEach(function (o) { o.disabled = !exists(vals.concat([o.value])); });
      var cur = s[j].selectedOptions[0];
      if (allowChange && cur && cur.disabled) {
        var ok = opts.filter(function (o) { return !o.disabled; })[0];
        if (ok) { s[j].value = ok.value; changed = true; }
      }
      vals.push(s[j].value);
    }
    return changed;
  }

  function applyAll(allowChange) {
    if (!product) return;
    Array.prototype.slice.call(document.querySelectorAll('variant-selects')).forEach(function (vs) { normalize(vs, allowChange); });
  }

  document.addEventListener('change', function (e) {
    if (!product || !e.target || !e.target.matches || !e.target.matches('select')) return;
    var vs = e.target.closest('variant-selects');
    if (!vs) return;
    normalize(vs, true);
  }, true);

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { applyAll(false); }, 150);
  }

  function start() {
    fetch(window.location.pathname.replace(/\/$/, '') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        applyAll(false);
        new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
